import { render, staticRenderFns } from "./ManageClientsFilter.vue?vue&type=template&id=1f4327aa"
import script from "./ManageClientsFilter.vue?vue&type=script&lang=js"
export * from "./ManageClientsFilter.vue?vue&type=script&lang=js"
import style0 from "./ManageClientsFilter.vue?vue&type=style&index=0&id=1f4327aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports